import { Truck, FlaskConical, MapPin, ShieldCheck } from "lucide-react";

const items = [
  { icon: Truck, text: "Free shipping on orders over $75" },
  { icon: FlaskConical, text: "Third-party lab tested" },
  { icon: MapPin, text: "Texas grown · Locally operated" },
  { icon: ShieldCheck, text: "21+ only · Farm Bill compliant" },
];

export default function TopBar() {
  return (
    <div className="bg-navy text-sand text-xs hidden md:block border-b border-copper/15" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-9">
        <div className="flex items-center gap-8 overflow-hidden">
          {items.map((it) => (
            <div key={it.text} className="flex items-center gap-2 text-sand/80 tracking-wide">
              <it.icon size={13} className="text-copper flex-shrink-0" strokeWidth={1.5}/>
              <span className="uppercase text-[10.5px] tracking-[0.18em]">{it.text}</span>
            </div>
          ))}
        </div>
        <div className="hidden lg:flex items-center gap-2 text-[10.5px] uppercase tracking-[0.18em] text-copper">
          <span className="inline-flex items-center gap-1 border border-copper/40 px-2 py-0.5">21+</span>
          <span>Adults only</span>
        </div>
      </div>
    </div>
  );
}
